import { client } from '~/notes/api/client'
import type { components } from '~/notes/api/client/types'

type UserGroupMembershipResponse =
  components['schemas']['UserGroupMembershipResponse.7a50a48']

export async function getUserGroupMembership(): Promise<UserGroupMembershipResponse> {
  const { data, error, response } = await client.GET(
    '/openapi/user/groupMembership',
  )
  if (error || !response.ok || !data) {
    const status = response?.status ?? 'unknown'
    const errorText =
      error && typeof error === 'object' ? JSON.stringify(error) : String(error)
    throw new Error(
      `Failed to fetch user group membership: ${status} ${errorText}`,
    )
  }
  return data
}
